import { createContext, useContext } from 'react';

export type ToastTone = 'info' | 'success' | 'warning' | 'danger';

export interface ToastOptions {
  title?: string;
  description: string;
  tone?: ToastTone;
  /** Czas widocznosci w milisekundach. `0` — komunikat zostaje do zamkniecia. */
  duration?: number;
}

export interface ToastContextValue {
  /** Pokazuje komunikat i zwraca jego identyfikator. */
  showToast: (options: ToastOptions) => string;
  dismissToast: (id: string) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

/** Dostep do komunikatow ulotnych. Rzuca poza `ToastProvider`. */
export function useToast(): ToastContextValue {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast musi być użyte wewnątrz ToastProvider.');
  }
  return context;
}
